@if(options?.series){
<ag-charts
        [options]="options"
    ></ag-charts>
}
